import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=5d005007&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=5d005007&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d005007",
  null
  
)

export default component.exports